import React, { useState, useEffect } from "react";
import { Layout } from "./components/dashboard/layout";
import Select from "react-select";
import { Avatar, Box, Typography } from "@mui/material";
import keys from "./constants";

const BASE_URL = "https://raptornet.aischennai.org/screening-manager";

const PinLookup = () => {
  const [users, setUsers]               = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [pin, setPin]                   = useState(null);
  const [generatedAt, setGeneratedAt]   = useState(null);
  const [loading, setLoading]           = useState(false);

  useEffect(() => {
    fetch(`${BASE_URL}/gate-api/getAllUsers.php`)
      .then((res) => res.json())
      .then((data) => {
        const options = (data.users || []).map((u) => ({
          label: `${u.enroll_no} - ${u.full_name}`,
          value: u.enroll_no,
          name:  u.full_name,
          grade: u.grade,
          person_type: u.person_type,
        }));
        setUsers(options);
      })
      .catch((err) => console.error("Error fetching users:", err));
  }, []);

  const handleUserSelect = (selected) => {
    setSelectedUser(selected);
    setPin(null);
    setGeneratedAt(null);
    if (!selected) return;

    setLoading(true);
    fetch(`${BASE_URL}/gate-api/pinLookup.php?search=${encodeURIComponent(selected.value)}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.data.length > 0) {
          setPin(data.data[0].pin);
          setGeneratedAt(data.data[0].generated_at);
        }
      })
      .catch((err) => console.error("Error fetching PIN:", err))
      .finally(() => setLoading(false));
  };

  return (
    <Layout>
        <Box sx={{ p: 4 }}>
        {/* Title — blue like manual check-in */}
        <Typography
          variant="h4"
          sx={{ mb: 3, fontWeight: 600, color: "#2E3192" }}
        >
          PIN Lookup
        </Typography>

        {/* Search — same react-select style */}
        <Select
          options={users}
          onChange={handleUserSelect}
          placeholder="Search by Name or ID..."
          isClearable
          styles={{
            container: (base) => ({ ...base, marginBottom: "2rem", width: "100%" }),
            control: (base) => ({
              ...base,
              borderRadius: "4px",
              padding: "6px",
              borderColor: "#ccc",
              boxShadow: "none",
              "&:hover": { borderColor: "#2E3192" },
            }),
          }}
        />

        {loading && (
          <Typography textAlign="center" color="text.secondary">
            Loading...
          </Typography>
        )}

        {/* Card container — same as previous screenshot */}
        {selectedUser && !loading && (
          <Box
            sx={{
              background: "#fff",
              borderRadius: "16px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
              p: 4,
              textAlign: "center",
            }}
          >
            {/* Photo */}
            <Avatar
              src={`${BASE_URL}/api/images/${selectedUser.value}.jpg`}
              alt={selectedUser.name}
              sx={{
                width: 150,
                height: 150,
                margin: "0 auto 1rem",
                border: "4px solid #2E3192",
              }}
            />

            {/* Name */}
            <Typography variant="h4" fontWeight={600} color="#1a1a2e">
              {selectedUser.name}
            </Typography>

            {/* ID */}
            <Typography variant="h5" color="text.secondary" mb={1}>
              {selectedUser.value}
            </Typography>

            {/* Grade if student */}
            {selectedUser.person_type === "3" && selectedUser.grade && (
              <Typography variant="h6" color="text.secondary" mb={1}>
                Grade Level: {selectedUser.grade}
              </Typography>
            )}

            {/* PIN box */}
            <Box
              sx={{
                background: "#f0f4ff",
                borderRadius: "12px",
                p: 3,
                mt: 2,
              }}
            >
              <Typography variant="body2" color="text.secondary" mb={1}>
                Gate Access PIN
              </Typography>
              {pin ? (
                <Typography
                  variant="h2"
                  fontWeight={700}
                  fontFamily="monospace"
                  letterSpacing="0.5rem"
                  color="#2E3192"
                >
                  {pin}
                </Typography>
              ) : (
                <Typography color="warning.main" fontWeight={600}>
                  No PIN assigned yet
                </Typography>
              )}
              {generatedAt && (
                <Typography
                  variant="caption"
                  color="text.disabled"
                  display="block"
                  mt={1}
                >
                  Generated: {new Date(generatedAt).toLocaleString()}
                </Typography>
              )}
            </Box>
          </Box>
        )}
      </Box>
    </Layout>
  );
};

export default PinLookup;
